import { render } from "./ConfigureEmailEditPane.vue?vue&type=template&id=8bdfe3d8&scoped=true&ts=true"
import script from "./ConfigureEmailEditPane.vue?vue&type=script&lang=ts"
export * from "./ConfigureEmailEditPane.vue?vue&type=script&lang=ts"

import "./ConfigureEmailEditPane.vue?vue&type=style&index=0&id=8bdfe3d8&scoped=true&lang=css"

import exportComponent from "C:\\Ventla new admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8bdfe3d8"]])

export default __exports__